import styled from "styled-components";
import {Link} from "react-router-dom";

export const ItemWrapper = styled(Link)`
  padding: 1.4rem 1.4rem 1.4rem 1rem;
  position: relative;
  
  p {
    font-size: .95rem;
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(108, 140, 191, 0.2);
  }

  i:not(.arrow)::before {
    color: var(--sky-blue);
    font-size: 1.2rem;
  }

  .arrow {
    transform: rotateZ(90deg);
    display: inline-block;

    &::before {
      font-size: .4rem;
      font-weight: bold;
    }
  }
`;

export const BadgeAlert = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: var(--warning-color);
  right: -2px;
`;
